import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=10a5ad8c"
import script from "./AddPlan.vue?vue&type=script&lang=js"
export * from "./AddPlan.vue?vue&type=script&lang=js"
import style0 from "./AddPlan.vue?vue&type=style&index=0&id=10a5ad8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports